@if (strategy) {
  <div class="counter">
    <h3>Counter-strategy</h3>
    <mat-form-field>
      <mat-label>Enter the strategy title</mat-label>
      <input matInput type="text" placeholder="" [(ngModel)]="strategy.title" autocomplete="off">
    </mat-form-field>
    <div fxLayout="row" fxFlexFill fxLayoutGap="10px">
      <mat-form-field fxFlex>
        <mat-label>Initial stamps</mat-label>
        <input matInput type="number" placeholder="" min="0" max="50" step="1"  [(ngModel)]="strategy.stampCount" autocomplete="off">
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>Max stamps</mat-label>
        <input matInput type="number" placeholder="" min="1" max="50" step="1"  [(ngModel)]="strategy.maxStampCount" autocomplete="off">
      </mat-form-field>
    </div>
    <!-- <div *ngIf="strategy" class="stars">
    <div class="star" *ngFor="let i of Array.from(Array(strategy.maxStampCount).keys())"
      [class.on]="parseInt(i) < strategy.stampCount">
    </div>
    <div class="stamps-count">{{ strategy.stampCount }}/{{ strategy.maxStampCount }} stamps</div>
  </div> -->
</div>
}